import React from 'react'

import Title from '../../Components/Admin/Title'

import { Link, useNavigate } from 'react-router-dom'

import { FaUsers } from "react-icons/fa";

import useFetchApi from '../../hooks/useFetchApi';

import usePagination from '../../hooks/usePagination';

import Swal from 'sweetalert2';
import { USER_DELETE_URL, USER_FETCH_URL } from '../../utils/Constant';
import { authHeaders } from '../../utils/api';

function User() {

    const navigate = useNavigate();

    // =========================
    // FETCH USERS
    // =========================

    //const url = 'http://localhost:8000/api/admin/users';

    // const { data } = useFetchApi({
    //     url,
    //     dataKey: 'users'
    // });


    const { data } = useFetchApi({
        url: USER_FETCH_URL,
        dataKey: 'users',
        authType: 'admin'// ✅ auth token
    });


    console.log(data);


    // =========================
    // PAGINATION
    // =========================

    const {
        currentItems,
        getVisiblePages,
        currentPage,
        setCurrentPage,
        handlePrev,
        handleNext,
    } = usePagination({
        data,
        itemShowPerPage: 5
    });

    // =========================
    // EDIT
    // =========================

    const handleEdit = async (id) => {

        navigate(`/admin/users/${id}/edit`);
    }

    // =========================
    // DELETE
    // =========================

    const handleDelete = async (id) => {

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!confirm.isConfirmed) return;

        try {

            const res = await fetch(
                USER_DELETE_URL(id),
                {
                    method: "DELETE",
                    headers: authHeaders(),
                }
            );

            const data = await res.json();

            if (!res.ok) {

                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: data.message || 'Delete failed',
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: data.message,
                timer: 2000,
                showConfirmButton: false,
            });

            // refresh data
            window.location.reload();

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });
        }
    };

    return (
        <>

            <Title
                icon={FaUsers}
                title='Users'
            />

            <div className="bg-white rounded shadow-lg mt-5">

                <h4
                    className="
                        text-lg
                        p-4
                        font-semibold
                        border-b
                        flex
                        justify-between
                        items-center
                    "
                >

                    Users

                    <Link
                        to="/admin/users/create"
                        className='btn btn-accent btn-sm text-white shadow-md'
                    >
                        Add User
                    </Link>

                </h4>

                <div className="p-4 ">

                    <table className="border w-full">

                        <thead className='bg-gray-400 border p-2'>

                            <tr className="border p-2">

                                <th className="border p-2">
                                    Sl No.
                                </th>

                                <th className="border p-2">
                                    Name
                                </th>

                                <th className="border p-2">
                                    Mobile
                                </th>

                                <th className="border p-2">
                                    Email
                                </th>

                                <th className="border p-2">
                                    Type
                                </th>

                                <th className="border p-2">
                                    Status
                                </th>

                                <th className="border p-2">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody className='border p-2'>

                            {currentItems.map((item, index) => {

                                const {
                                    id,
                                    name,
                                    mobile_no,
                                    email,
                                    type,
                                    status_label,
                                    status_badge
                                } = item;

                                return (

                                    <tr
                                        className='border p-2'
                                        key={id}
                                    >

                                        <td className='border p-2 text-sm'>
                                            {index + 1}
                                        </td>

                                        <td className='border p-2 text-sm'>
                                            {name}
                                        </td>

                                        <td className='border p-2 text-sm'>
                                            {mobile_no}
                                        </td>

                                        <td className='border p-2 text-sm'>
                                            {email}
                                        </td>

                                        <td className='border p-2 text-sm'>

                                            <span
                                                className={`
                                                    badge
                                                    ${type == 1
                                                        ? 'badge-warning'
                                                        : 'badge-info'
                                                    }
                                                `}
                                            >
                                                {type == 1
                                                    ? 'Admin'
                                                    : 'User'
                                                }
                                            </span>

                                        </td>

                                        <td className='border p-2 text-sm'>

                                            <span
                                                className={`
                                                    badge
                                                    badge-${status_badge}
                                                    badge-outline
                                                `}
                                            >
                                                {status_label}
                                            </span>

                                        </td>

                                        <td className='border p-2 text-sm'>

                                            <div className="dropdown dropdown-end">

                                                <div
                                                    tabIndex={0}
                                                    role="button"
                                                    className="
                                                        btn
                                                        btn-xs
                                                        btn-info
                                                        m-1
                                                    "
                                                >
                                                    Action
                                                </div>

                                                <ul
                                                    tabIndex={0}
                                                    className="
                                                        dropdown-content
                                                        menu
                                                        bg-base-100
                                                        rounded-box
                                                        z-[1]
                                                        w-52
                                                        p-2
                                                        shadow
                                                    "
                                                >

                                                    <li>

                                                        <button
                                                            onClick={() => handleEdit(id)}
                                                            className="text-green-500"
                                                        >
                                                            Edit
                                                        </button>

                                                    </li>

                                                    <li>

                                                        <button
                                                            onClick={() => handleDelete(id)}
                                                            className="text-red-500"
                                                        >
                                                            Delete
                                                        </button>

                                                    </li>

                                                </ul>

                                            </div>

                                        </td>

                                    </tr>
                                )
                            })}

                        </tbody>

                    </table>

                    {/* PAGINATION */}

                    <div className="paginationContiner flex justify-between items-center my-4">

                        <button
                            className='btn btn-outline'
                            onClick={handlePrev}
                        >
                            Prev
                        </button>

                        <div className="join">

                            {getVisiblePages().map((page) => (

                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`
                                        join-item
                                        btn
                                        btn-sm
                                        ${currentPage === page
                                            ? "btn-primary text-white"
                                            : "btn-outline"
                                        }
                                    `}
                                >
                                    {page + 1}
                                </button>

                            ))}

                        </div>

                        <button
                            className='btn btn-outline'
                            onClick={handleNext}
                        >
                            Next
                        </button>

                    </div>

                </div>

            </div >

        </>
    )
}

export default User